import { Component, OnInit, Input, OnChanges, SimpleChanges, output } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit, OnChanges {

  constructor() { }
  @Input() alertInfo: any;
  readonly onClose = output();
  alertTheme: any;
  iconclass ="fas fa-check"
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.alertInfo.type === 'error') {
      this.iconclass = "fas fa-exclamation";
      this.alertTheme = "flex align-center justify-between error-page-alert";
    }
    else if (this.alertInfo.type === 'warn') {
      this.iconclass = "fas fa-exclamation";      
      this.alertTheme = "flex align-center justify-between warn-page-alert";
    }
    else if (this.alertInfo.type === 'info') {
      this.iconclass = "fas fa-info";
      this.alertTheme = "flex align-center justify-between success-page-alert";
    }
  }

  onCloseAlert(){
    this.onClose.emit();
  }
}
